import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CookiePreferencesRoutingModule } from './cookie-preferences-routing.module';
import { CookiePreferencesComponent } from './cookie-preferences.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
    declarations: [
        CookiePreferencesComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        TranslateModule,
        MatSnackBarModule,
        CookiePreferencesRoutingModule
    ]
})
export class CookiePreferencesModule { } 